import React from 'react';

import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Button from 'react-bootstrap/lib/Button';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import fetch from '../../core/fetch';
import s from './ServicesCategories.scss';
import { notFoundImageURL } from '../../config';
import sip from './icons/sip.svg';
import planowanie from './icons/planowanie.svg';
import zezwolenia from './icons/zezwolenia.svg';
import nieruchomosci from './icons/nieruchomosci.svg';
import ochr_srodowiska from './icons/ochr_srodowiska.svg';
import zgloszenia from './icons/zgloszenia.svg';
import oplaty from './icons/oplaty.svg';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../utils/utils';


class ServicesCategories extends React.Component {
  state = {
    categories: [],
    colors: 'normal',
    style: {},
    icons: {
      sip,
      planowanie,
      zezwolenia,
      nieruchomosci,
      ochr_srodowiska,
      zgloszenia,
      oplaty,
    },
    buttons: {
      sip: false,
      planowanie: false,
      zezwolenia: false,
      nieruchomosci: false,
      ochr_srodowiska: false,
      zgloszenia: false,
      oplaty: false,
    },
  };

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let style = {};
    if (colors !== 'normal') {
      style = headerStyle[colors];
    }
    this.setState({ colors, style });

    let categories = [];

    const url = `${process.env.API_URL}/eservices/categories/`;
    fetch(url)
      .then(r => r.json())
      .then(resp => {
        categories = resp;
        this.setState({ categories });
      });
  }

  toggleButton = (e, category) => {
    this.setState({
      buttons: {
        ...this.state.buttons,
        [category.icon_name]: !this.state.buttons[category.icon_name],
      },
    });
    this.props.onChange(category.id);
  };

  render() {
    return (
      <div className="col-lg-12">
        {this.state.categories.map((category, i) =>
          <Col key={i} xs={12} sm={6} md={4} style={{ paddingTop: '5px', paddingBottom: '5px' }}>
            <Button
              className={'category-button'}
              style={{ padding: '1px 1px 1px 1px' }}
              onClick={e => this.toggleButton(e, category)}
            >
              <div
                className={this.state.buttons[category.icon_name] ? 'col-xs-3 button-items-selected' : 'col-xs-3 button-items'}
                style={this.state.buttons[category.icon_name] ? null : this.state.style}
              >
                <img
                  className={this.state.style ? `category-icon-${this.state.style.color}` : 'category-icon-black'}
                  src={this.state.icons[category.icon_name] ? this.state.icons[category.icon_name] : notFoundImageURL}
                  style={!this.state.icons[category.icon_name] ? { width: '60pt', height: '60pt' } : null} alt="category icon"
                />
              </div>
              <div
                className={this.state.buttons[category.icon_name] ? 'col-xs-9 button-items-selected' : 'col-xs-9 button-items'}
                style={this.state.buttons[category.icon_name] ? { fontSize: `${this.props.fontSize}rem`, color: this.state.style.color } : { fontSize: `${this.props.fontSize}rem`, ...this.state.style }}
              >
                <b>{category.name}</b>
              </div>
            </Button>
          </Col>,
        )}
      </div>
    );
  }
}

ServicesCategories.propTypes = {
};

const mapState = state => ({
  fontSize: state.runtime.fontSize,
});

export default withStyles(s)(connect(mapState)(ServicesCategories));



// WEBPACK FOOTER //
// src/components/ServicesCategories/ServicesCategories.js